<template>

<div class="information">

	<div class="information-title">Further information</div>

	<app-text v-if="recommendation.information.enabled === $constants.recommendation.text.text" :text="recommendation.information.text" />

	<div class="information-blocks" v-if="recommendation.information.enabled === $constants.recommendation.text.blocks">

		<template v-for="block in recommendation.information.blocks">

			<div class="information-blocks-item" v-if="visible(blocks[block])" :class="{'is-active': activeBlock === block}" :key="block" v-on:click="onBlockClick(block)">

				{{ blocks[block].title }}

			</div>

		</template>

	</div>

	<app-text v-if="activeBlock" :text="blocks[activeBlock].text" v-on:close="activeBlock = false" :fixed="window.is.mobile" />

</div>

</template>

<script>

export default {

	props: ['recommendation'],

	data: function() {

		return {
			activeBlock: false
		}

	},

	methods: {

		onBlockClick: function(block) {

			this.activeBlock = (this.activeBlock === block) ? false : block

		}

	}

}

</script>

<style scoped>

.information {
	margin-bottom: 32px;
}

.is-mobile .information {
	margin-bottom: 0px;
}

.information-title {
	font-weight: 100;
	font-size: 24px;
	line-height: 26px;
	letter-spacing: 2px;
	color: #343434;
	text-transform: uppercase;
	margin-bottom: 32px;
}

.is-mobile .information-title {
	font-size: 18px;
	line-height: 18px;
}

.information-blocks {
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	margin-bottom: 16px;
}

.is-mobile .information-blocks {
	flex-direction: column;
	margin-bottom: 0px;
}

.information-blocks-item {
	width: calc(50% - 10px);
	border-radius: 24px;
	border: 2px solid var(--primary-color);
	color: #343434;
	padding: 16px 16px 16px 86px;
	min-height: 90px;
	cursor: pointer;
	display: flex;
	margin-bottom: 20px;
	align-items: center;
	font-size: 20px;
	line-height: 24px;
	font-weight: 600;
	background-image: url(~@/assets/recommendation.information.svg);
	background-repeat: no-repeat;
	background-position: 16px 16px;
	transition: all 300ms ease-in-out;
}

.is-mobile .information-blocks-item {
	width: 100%;
	font-size: 14px;
	line-height: 18px;
}

.information-blocks-item:nth-child(odd) {
	margin-right: 20px;
}

.is-mobile .information-blocks-item:nth-child(odd) {
	margin-right: 0px;
}

.information-blocks-item:hover {
	background-color: var(--primary-color);
	color: #fff;
}

.information-blocks-item.is-active,
.information-blocks-item.is-active:hover {
	background-color: #343434;
	border-color: #343434;
	color: #fff;
}

.information-blocks-item.is-active:after {
	content: ' ';
	position: absolute;
	width: 0;
	height: 0;
	border-style: solid;
	border-width: 12px 12px 0 12px;
	border-color: #343434 transparent transparent transparent;
	left: 50%;
	bottom: -12px;
	margin-left: -12px;
}

</style>